import { render, staticRenderFns } from "./Dialogs_GetShopMsg.vue?vue&type=template&id=b1d4b0c0&scoped=true&"
import script from "./Dialogs_GetShopMsg.vue?vue&type=script&lang=js&"
export * from "./Dialogs_GetShopMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d4b0c0",
  null
  
)

export default component.exports